module.exports = __webpack_public_path__ + "media/images/user-icon-1f8b969dbb5c5573f5be138ccbe95d40.svg";